import { getStripeCard, getToken } from '../../utils/stripe';
import { errorDescriptionFromResponse } from '../../utils/error';

export default function ModalEditPaymentController(
  Account,
  Checkout,
  $uibModal,
  $uibModalInstance,
  $http,
  $timeout,
  toaster,
  $rootScope,
  $cacheFactory,
  parentVM
) {
  'ngInject';

  this.cancel = () => $uibModalInstance.dismiss('cancel');

  this.$http = $http;
  this.$timeout = $timeout;
  this.$cacheFactory = $cacheFactory;
  this.$rootScope = $rootScope;
  this.toaster = toaster;
  this.account = $rootScope.account;
  this.Account = Account;

  this.states = [];
  this.$http.get('/img/states.json').then((response) => {
    this.states = response.data;
  });

  this.countries = [];
  this.$http.get('/img/countries.json').then((response) => {
    this.countries = response.data;
  });

  this.billing = angular.copy(parentVM.billing);
  this.cardOnFile = angular.copy(parentVM.cardOnFile);
  if (!this.billing.country || this.billing.country == '') {
    this.billing.country = 'US';
  }

  this.stripeCard = getStripeCard();

  this.checkPreviousSelectedPayment = () => {
    const paymentException =
      this.billing.payment_method === 'check' || this.billing.payment_method === 'po';
    if (Checkout.currentInterval(this.billing) === 'month' && paymentException) {
      this.showAllPaymentOptions = true;
    }
  };

  this.changePaymentMethod = () => {
    this.checkPreviousSelectedPayment();
    this.billing.payment_method = null;
    this.cardOnFile = null;
    this.newStripeToken = null;
    this.changingPaymentMethod = true;
    if (Checkout.currentInterval(this.billing) === 'month') {
      this.selectedInterval = 'monthly';
    }
  };

  this.hasPaymentMethod = () => {
    return (
      this.billing.payment_method &&
      _.includes(['cc', 'ach', 'po', 'check'], this.billing.payment_method)
    );
  };

  if (!this.hasPaymentMethod()) {
    this.changePaymentMethod();
  }

  this.addNewCard = () => {
    this.addingCard = true;
    getToken(this.stripeCard)
      .then((token) => {
        this.$timeout(() => {
          this.newStripeToken = token.id;
          this.cardOnFile = token.card;
        });
      })
      .catch((err) => {
        this.$timeout(() => {
          this.toaster.pop('warning', 'Unable to process credit card: ' + err);
        });
      })
      .finally(() => {
        this.addingCard = false;
      });
  };

  this.openPlaidLink = () => {
    _createLinkToken().then((linkToken) => {
      Plaid.create({
        token: linkToken,
        onSuccess: (public_token, metadata) => _onBankAccountLinkedViaPlaid(public_token, metadata),
      }).open();
    });
  };

  this.onSelectPaymentMethod = (m) => {
    this.billing.payment_method = m;
    if (m == 'ach') {
      this.openPlaidLink();
    }
  };

  const _createLinkToken = () => {
    console.log('Creating Plaid link token');

    return this.$http
      .post(`${API_ROOT}/plaid/create_link_token`)
      .then((response) => {
        const linkToken = response.data.link_token;
        console.log('Plaid link_token', linkToken);
        return linkToken;
      })
      .catch((err) => {
        console.error('Error creating Plaid link token', err);
        this.toaster.pop('warning', 'We were unable to connect to our payment provider.');
      });
  };

  const _onBankAccountLinkedViaPlaid = (public_token, metadata) => {
    console.log('Plaid public_token', public_token);
    console.log('Plaid metadata', metadata);

    this.$http
      .post(`${API_ROOT}/plaid/exchange_token`, {
        public_token: public_token,
        plaid_account_id: metadata.account_id,
      })
      .then((response) => {
        this.billing.payment_method = 'ach';
        this.newStripeToken = response.data.stripe_bank_account_token;
        this.cardOnFile = null;
      })
      .catch((err) => {
        console.error('Error exchanging Plaid token', err);
        this.toaster.pop(
          'warning',
          'We were unable to associate your bank account with our payment provider.'
        );
        // XXX: TODO: save the public_token so that we can manually exchange/link
      });
  };

  this.update = () => {
    this.submitting = true;
    let updates = {
      address: this.billing.address,
      city: this.billing.city,
      country: this.billing.country,
      state: this.billing.state,
      email: this.billing.email,
      postal_code: this.billing.postal_code,
    };
    if (this.changingPaymentMethod) {
      updates.payment_method = this.billing.payment_method;
    }
    if (this.newStripeToken) {
      updates.stripe_token = this.newStripeToken;
    }
    this.Account.updateBilling(updates)
      .$promise.then((billing) => {
        // Invalidate cache
        this.$cacheFactory.get('$http').remove(`${API_ROOT}/account`);
        this.$rootScope.account.payment_method = billing.payment_method;
        this.cancel();
        parentVM.reload();
      })
      .catch((err) => {
        console.log(err);
        let errorDetails = errorDescriptionFromResponse(err);
        this.toaster.pop('warning', 'Error updating payment settings', errorDetails);
      })
      .finally(() => {
        this.submitting = false;
      });
  };
}



// WEBPACK FOOTER //
// ./app/pages/settings/modal-edit-payment.js